import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Home } from './pages/Home'
import { Profile } from './pages/Profile'
import { Password } from './pages/Password'
import { Login } from './pages/Login'
import { RequireAuth } from './context/RequireAuth'
import { Notfound } from './pages/Notfound'
import { Voter } from './pages/Voter'
import { ConfigProvider } from 'antd'
import { Picture } from './pages/Picture'

function App() {

  return (
    <ConfigProvider
      theme={
        {
          token: {
            colorPrimary: "#Fd0178",

          }
        }
      }>
      <BrowserRouter>
        <div>
          <ToastContainer />
          <Routes>
            <Route path="*" element={<Notfound />} />
            <Route path="/login" element={<Login />} />
            <Route path="/voter" element={
              <RequireAuth>
                <Voter />
              </RequireAuth>
            } />
            <Route path="/user/profile" element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            } />
            <Route path="/user/picture" element={
              <RequireAuth>
                <Picture />
              </RequireAuth>
            } />
            <Route path="/user/password" element={
              <RequireAuth>
                <Password />
              </RequireAuth>
            } />
            <Route path="/" element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            } />
          </Routes>
        </div>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
